module.exports = __webpack_public_path__ + "static/media/32_A.128505d5.png";